"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listOptions = void 0;
exports.listOptions = {
    options: ['list'],
    list: {
        options: ['unordered', 'ordered'],
        unordered: { className: 'rich-text-editor__toolbar__button' },
        ordered: { className: 'rich-text-editor__toolbar__button' }
    }
};
//# sourceMappingURL=list.js.map